import { makeStyles } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import { CollectionListUrlSortField } from "@saleor/collections/urls";
import ButtonMultiAction from "@saleor/components/ButtonMultiAction";
import { Container } from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { CollectionList_collections_edges_node } from "../../types/CollectionList";
import CollectionList from "../CollectionList/CollectionList";
import {
  CollectionFilterKeys,
  CollectionListFilterOpts,
  createFilterStructure
} from "./filters";

const useStyles = makeStyles(
  _ => ({
    btnActions: {
      "& div": {
        "&:hover": {
          fontWeight: 600
        },
        fontWeight: 500
      },
      "&:hover": {
        backgroundColor: "#F4F8FF",
        color: "#0030FF",
        fontWeight: 600
      }
    },
    btnCreateCollection: {
      "& div": {
        fontWeight: 600
      },
      "& span": {
        color: "#0030FF"
      },
      "&:hover": {
        backgroundColor: "#FFDB00"
      },
      backgroundColor: "#FFDB00",
      border: "1px solid #FFDB00",
      borderRadius: "8px",
      float: "right"
    },
    listItems: {
      minWidth: "150px",
      textTransform: "none"
    }
  }),
  { name: "CollectionListPage" }
);

export interface CollectionListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<CollectionFilterKeys, CollectionListFilterOpts>,
    SortPage<CollectionListUrlSortField>,
    TabPageProps {
  collections: CollectionList_collections_edges_node[];
  onAddNationwide: () => void;
}

const CollectionListPage: React.FC<CollectionListPageProps> = props => {
  const {
    currencySymbol,
    currentTab,
    disabled,
    filterOpts,
    initialSearch,
    onAdd,
    onAddNationwide,
    onAll,
    onFilterChange,
    onSearchChange,
    onTabChange,
    onTabDelete,
    onTabSave,
    tabs,
    ...listProps
  } = props;
  const intl = useIntl();
  const classes = useStyles(props);

  const structure = createFilterStructure(intl, filterOpts);

  const breadcrumbDirectory = [
    {
      name: "Collections"
    }
  ];

  return (
    <Container>
      <PageBreadcrumbNavigation items={breadcrumbDirectory} />
      <PageHeader title={intl.formatMessage(sectionNames.collections)}>
        <ButtonMultiAction
          btnClassStyle={classes.btnCreateCollection}
          itemBtnClassStyle={classes.listItems}
          hideDivider={true}
          actions={[
            {
              action: onAdd,
              className: classes.btnActions,
              label: "Local"
            },
            {
              action: onAddNationwide,
              className: classes.btnActions,
              label: "Nationwide"
            }
          ]}
          label="Create collection"
          placement="bottom-end"
        />
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder="Search Collection"
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <CollectionList disabled={disabled} {...listProps} />
      </Card>
    </Container>
  );
};
CollectionListPage.displayName = "CollectionListPage";
export default CollectionListPage;
